import React from 'react'
import { useEffectEvent } from './use-effect-event'

export function useFormReset<T>(
  ref: React.RefObject<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null>,
  initialValue: T,
  onReset: (value: T) => void
) {
  let resetValue = React.useRef(initialValue)
  let handleReset = useEffectEvent(() => {
    if (onReset) {
      onReset(resetValue.current)
    }
  })

  React.useEffect(() => {
    let form = ref?.current?.form
    form?.addEventListener('reset', handleReset)
    return () => {
      form?.removeEventListener('reset', handleReset)
    }
  }, [ref, handleReset])
}
